import { Container } from '@carboncopyco/ui';
import type React from 'react';

export const WorkspacePageHeader = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  return (
    <div className="w-full h-40 shrink-0 bg-ds-natural-50">
      <Container>
        <div className="w-full h-full flex items-center justify-between">
          {children}
        </div>
      </Container>
    </div>
  );
};
